// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import PrivateClaimNumberCellRenderer from '../../shared/report-cell-renderers/private-claim-number-cell-renderer';
import PrivateCreditMemoCellRenderer from '../../shared/report-cell-renderers/private-credit-memo-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getClaimHistoryColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'accountNumber',
            field: 'accountNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_LOCATION'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PrivateClaimNumberCellRenderer,
            colId: 'claimNumber',
            field: 'claimNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CLAIM'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'claimTypeDescription ',
            field: 'claimTypeDescription',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CLAIM_TYPE'),
            width: 150

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'subClaimTypeDescription ',
            field: 'subClaimTypeDescription',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('SUB_CLAIM_TYPE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'programName',
            field: 'programName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PROGRAM'),
            valueGetter: params => params.data.programName ? `${params.data.programName} - ${params.data.programDescription}` : '',
            width: 240
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'claimStatusDescription',
            field: 'claimStatusDescription',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STATUS'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'submissionDate',
            field: 'submissionDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('SUBMITTED'),
            width: 100

        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'reference1',
            field: 'reference1',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('WORK_ORDER_ONE'),
            width: 150

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'reference2',
            field: 'reference2',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('WORK_ORDER_TWO'),
            width: 150

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'failureDate',
            field: 'failureDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('FAILED'),
            width: 130

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'repairDate',
            field: 'repairDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REPAIRED'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'failurePart',
            field: 'failurePart',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('FAILED_PART'),
            width: 130

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'creditMemoDate',
            field: 'creditMemoDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CREDIT_MEMO_PROCESS_DATE'),
            width: 240

        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PrivateCreditMemoCellRenderer,
            colId: 'creditMemoNumber',
            field: 'creditMemoNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CREDIT_MEMO'),
            width: 150
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/claim-history/report-services/column-definitions.js